// @ts-strict-ignore
import {PlayerMapping, SettingType} from "@models";
import {Component, Injector} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {NotificationService, SimMaterialDialogService, SimSystemExtendedService} from "@services";

import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";

export interface PLAYER_MAPPING_CONFIGURATION_DIALOG_INPUT extends MatDialogDataBaseInput {
	playerMapping: PlayerMapping;
}

export interface PLAYER_MAPPING_CONFIGURATION_DIALOG_OUTPUT extends MatDialogDataBaseOutput {
	needsToRefreshPlayerMappingList: boolean;
	updatedPlayerMapping: PlayerMapping;
}

@Component({
	selector: "sim-player-mapping-configuration-dialog",
	templateUrl: "./player-mapping-configuration-dialog.component.html",
	styleUrls: ["./player-mapping-configuration-dialog.component.scss"],
	standalone: false,
})
export class PlayerMappingConfigurationDialogComponent extends BasicMaterialDialog<
	PlayerMappingConfigurationDialogComponent,
	PLAYER_MAPPING_CONFIGURATION_DIALOG_INPUT,
	PLAYER_MAPPING_CONFIGURATION_DIALOG_OUTPUT
> {
	T = Translations;
	SettingType = SettingType;

	hidePassword = true;
	needsToRefreshPlayerList: boolean;

	constructor(
		private translate: TranslateService,
		private SimDialogService: SimMaterialDialogService,
		private SimSystemExtendedService: SimSystemExtendedService,
		private SimNotificationService: NotificationService,
		_injector: Injector,
	) {
		super(_injector);
	}

	private updateAllPlayersTask: Promise<any> = null;

	public findMacAddressForPlayer(ip: string) {
		this.findMacAddress(ip).then((macAddress: string) => {
			this.data.playerMapping.macAddress = macAddress;
		});
	}

	public findMacAddressForConnectedMonitor(ip: string) {
		this.findMacAddress(ip).then((macAddress: string) => {
			this.data.playerMapping.connectedMonitorMacAddress = macAddress;
		});
	}

	public findMacAddress(ip: string) {
		if (ip) {
			return this.SimSystemExtendedService.getMacAddress(ip).then((getMacAddressResult) => {
				if (getMacAddressResult) {
					return getMacAddressResult;
				} else {
					this.SimNotificationService.notifyError(
						this.translate.instant(this.T.PLAYER_MAPPING_CONFIGURATION_DIALOG_COULD_NOT_FIND_MAC_ADDRESS),
					);
					return "";
				}
			});
		} else {
			return Promise.resolve("");
		}
	}

	public ok() {
		this.close({
			action: "ok",
			needsToRefreshPlayerMappingList: this.needsToRefreshPlayerList,
			updatedPlayerMapping: this.data.playerMapping,
		});
	}

	public cancel() {
		this.close({
			action: "cancel",
			needsToRefreshPlayerMappingList: this.needsToRefreshPlayerList,
			updatedPlayerMapping: this.data.playerMapping,
		});
	}

	public saveForAll() {
		this.SimDialogService.openConfirmationDialog({
			title: this.translate.instant(this.T.PLAYER_MAPPING_CONFIGURATION_CHANGE_ALL_PLAYER_CREDENTIALS),
			description: this.translate.instant(this.T.PLAYER_MAPPING_CONFIGURATION_WANT_TO_APPLY_CREDENTIALS_TO_ALL_PLAYERS),
			okText: this.translate.instant(this.T.ABSTRACT_VIEW_LIST_YES),
			cancelText: this.translate.instant(this.T.SCENARIO_DELETE_DIALOG_CANCEL),
		}).then((result) => {
			if (result.action == "ok") {
				this.updateAllPlayersTask = this.SimSystemExtendedService.updateAllPlayerCredentials({
					userName: this.data.playerMapping.deviceUsername,
					password: this.data.playerMapping.devicePassword,
					subnetMask: this.data.playerMapping.subnetMask,
				})
					.then(
						(result) => {},
						(err) => {
							this.SimNotificationService.notifyError(
								this.translate.instant(this.T.DIGITAL_SIGNAGE_COULD_NOT_UPDATE_PLAYER_MAPPING),
							);
						},
					)
					.then(() => {
						this.needsToRefreshPlayerList = true;
						this.SimNotificationService.notifySuccess(
							this.translate.instant(this.T.CONFIGURATION_EDITOR_PLAYER_MAPPINGS_SUCCESSFUL_UPDATE_ALL),
						);
					});
			}
		});
	}
}
